import {
	createBlueprint,
	CreateBlueprintInfo,
	getBlueprintContent,
	updateBlueprintContent
} from "core/blueprint/base/BlueprintService";
import { Field } from "core/field/FieldService";
import { Operation } from "rfc6902/diff";

const REPORT_BLUEPRINT_SUFFIX = "reports";

export type ReportBlueprint = {
	fields: Field[];
};

export function createReportBlueprint(
	info: CreateBlueprintInfo
): Promise<string> {
	return createBlueprint(REPORT_BLUEPRINT_SUFFIX, info);
}

export function getReportBlueprintContent(
	id: number
): Promise<ReportBlueprint> {
	return getBlueprintContent<ReportBlueprint>(REPORT_BLUEPRINT_SUFFIX, id);
}

export function updateReportBlueprintContent(
	id: number,
	content: Operation[]
): Promise<void> {
	return updateBlueprintContent(REPORT_BLUEPRINT_SUFFIX, id, content);
}
